import React from "react";
import { useNavigate } from "react-router-dom";
import LeftLayout from "../../../Components/LeftLayout";
import "./Email.css";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { Helmet } from "react-helmet-async";

const Email = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();

  const handleButton = () => {
    navigate("/Verify_email");
  };

  return (
    <div className="screen_split">
      <Helmet>
        <title>Verify Email | iON Merchant Portal</title>
        <meta name={t["Verify Email"]} />
      </Helmet>
      <LeftLayout />
      <div className="reset_form">
        <div className="verify_email_div">{t["Verify your Email"]}</div>
        <div className="login_text">
          {t["We've sent a link to your email address"]}:{" "}
          <span className="gmail_name">mark@gmail.com</span>
        </div>
        <button className="email_button" onClick={handleButton}>
          <span>{t["Skip Now"]}</span>
        </button>
        <button className="email_button" onClick={handleButton}>
          <span>{t["Email Verification"]}</span>
        </button>

        <div className="last_sec_email">
          {t["Didn't receive an email?"]}{" "}
          <span className="resend_span">{t["Resend"]}</span>
        </div>
      </div>
    </div>
  );
};

export default Email;
